import { useEffect } from 'react';
import { hideElement, showElement } from '../../../../services/utils/intercomUtils';

export const useDisableIntercom = () => {
    useEffect(() => {
        const hideIntercomElements = () => {
            const intercomElements = document.querySelectorAll('[id^="intercom-"], [class^="intercom-"]');
            intercomElements.forEach(hideElement);
            if (intercomElements.length > 0) {
                observer.disconnect();
            }
        };

        const observer = new MutationObserver(hideIntercomElements);

        const targetNode = document.body;
        const observerConfig = { childList: true, subtree: true };

        observer.observe(targetNode, observerConfig);

        return () => {
            const intercomElements = document.querySelectorAll('[id^="intercom-"], [class^="intercom-"]');
            intercomElements.forEach(showElement);
            observer.disconnect();
        };
    }, []);
};
